<template>
    <div>
        <button type="button" class="btn btn-default" @click="addField">
            <i class="fa fa-plus"></i> Tambah
        </button>
        <div style="padding-top: 10px">
            <div class="box box-primary">
                <div class="box-header with-border">
                    <h3 class="box-title">Custom Fields</h3>
                </div>
                <div class="box-body">
                    <span class="help-block" v-show="fields.length < 1">
                        Klik tombol di atas untuk menambahkan custom field
                    </span>
                    <div v-show="fields.length > 0" class="form-group">
                        <div class="col-sm-3">
                            <b>Nama Field</b> <span class="text-danger">*</span>
                        </div>
                        <div class="col-sm-3"><b>Tipe</b></div>
                        <div class="col-sm-3"><b>Opsi</b></div>
                    </div>

                    <!-- Field list -->
                    <draggable v-model="fields">
                        <div
                            v-for="(field, index) in fields"
                            :key="index"
                            :class="{
                                'form-group': true,
                            }"
                        >
                            <input
                                type="hidden"
                                :name="`fields[${index}][id]`"
                                :value="field.id"
                            />
                            <div class="col-sm-3">
                                <div
                                    class="drag-handle"
                                    title="Tahan dan geser untuk merubah urutan"
                                >
                                    <i class="fa fa-ellipsis-v" />
                                </div>
                                <input
                                    :name="'fields[' + index + '][label]'"
                                    :readonly="shouldDisable(field)"
                                    class="form-control"
                                    required
                                    type="text"
                                    v-model="field.label"
                                    style="
                                        max-width: 90%;
                                        display: inline-block;
                                    "
                                />
                            </div>
                            <div class="col-sm-3">
                                <v-select
                                    label="label"
                                    :value="field.type"
                                    @input="
                                        (input) =>
                                            handleTypeChange(input, field)
                                    "
                                    :options="types"
                                    :reduce="(type) => type.key"
                                    :disabled="shouldDisable(field)"
                                >
                                </v-select>
                                <input
                                    type="hidden"
                                    :name="'fields[' + index + '][type]'"
                                    :value="field.type"
                                />
                            </div>
                            <div class="col-sm-3">
                                <v-select
                                    v-if="
                                        field.type !== 'bank_transfer' &&
                                        hasOptions(field)
                                    "
                                    v-model="field.options"
                                    :name="'fields[' + index + '][options]'"
                                    :disabled="shouldDisable(field)"
                                    taggable
                                    multiple
                                >
                                    <template v-slot:no-options="{ searching }">
                                        <span
                                            style="opacity: 0.5"
                                            v-if="!searching"
                                            >Ketik kemudian tekan Enter</span
                                        >
                                    </template>
                                </v-select>
                                <template v-if="field.type === 'bank_transfer'">
                                    <input
                                        type="text"
                                        class="form-control"
                                        placeholder="Nama Bank"
                                        v-model="field.options.bank_name"
                                    />
                                    <input
                                        type="text"
                                        class="form-control"
                                        placeholder="No. Rekening"
                                        v-model="field.options.account_number"
                                    />
                                    <input
                                        type="text"
                                        class="form-control"
                                        placeholder="A\N"
                                        v-model="field.options.account_name"
                                    />
                                    <input
                                        type="number"
                                        class="form-control"
                                        placeholder="Harga"
                                        v-model="field.options.amount"
                                    />
                                    <input
                                        type="number"
                                        class="form-control"
                                        placeholder="Kode Unik"
                                        v-model="field.options.unique_code"
                                    />
                                </template>
                                <span
                                    v-if="errors[`fields.${index}.options`]"
                                    class="text-danger"
                                    >{{
                                        errors[`fields.${index}.options`]
                                    }}</span
                                >
                                <template
                                    v-if="
                                        field.type !== 'bank_transfer' &&
                                        hasOptions(field)
                                    "
                                >
                                    <input
                                        v-for="(
                                            option, optionIndex
                                        ) in field.options"
                                        :key="optionIndex"
                                        type="hidden"
                                        :name="
                                            'fields[' + index + '][options][]'
                                        "
                                        :value="option"
                                    />
                                </template>
                                <template
                                    v-else-if="field.type === 'bank_transfer'"
                                >
                                    <input
                                        v-for="key in Object.keys(
                                            field.options
                                        )"
                                        :key="key"
                                        type="hidden"
                                        :name="`fields[${index}][options][${key}]`"
                                        :value="field.options[key]"
                                    />
                                </template>
                                <span v-else class="help-block">
                                    Field tipe ini tidak memiliki opsi
                                </span>
                            </div>
                            <div class="col-sm-2">
                                <div class="checkbox">
                                    <label>
                                        <input
                                            type="checkbox"
                                            :name="`fields[${index}][is_required]`"
                                            v-model="field.is_required"
                                            value="1"
                                            :disabled="shouldDisable(field)"
                                        />
                                        <input
                                            type="hidden"
                                            :name="`fields[${index}][is_required]`"
                                            v-model="field.is_required"
                                            value="1"
                                            v-if="shouldDisable(field)"
                                        />
                                        Required
                                    </label>
                                </div>
                                <x-checkbox-wrapper label="Individual">
                                    <input
                                        type="checkbox"
                                        :name="`fields[${index}][is_individual]`"
                                        v-model="field.is_individual"
                                        value="1"
                                        :disabled="
                                            shouldDisable(field) ||
                                            field.type == 'image_upload' ||
                                            field.type == 'bank_transfer'
                                        "
                                        :title="
                                            field.type == 'image_upload' ||
                                            field.type == 'bank_transfer'
                                                ? 'Image Upload dan Bank Transfer harus individual'
                                                : null
                                        "
                                    />
                                    <input
                                        type="hidden"
                                        :name="`fields[${index}][is_individual]`"
                                        v-model="field.is_individual"
                                        value="1"
                                        v-if="
                                            shouldDisable(field) ||
                                            field.type == 'image_upload' ||
                                            field.type == 'bank_transfer'
                                        "
                                    />
                                </x-checkbox-wrapper>
                                <div
                                    class="help-block"
                                    v-if="field.type == 'checkbox'"
                                >
                                    Bila required, semua opsi wajib dicentang
                                </div>
                            </div>
                            <div class="col-sm-1">
                                <div class="box-tools pull-right">
                                    <button
                                        type="button"
                                        class="btn btn-box-tool"
                                        @click="removeField(index)"
                                    >
                                        <i class="fa fa-times"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </draggable>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.drag-handle {
    cursor: grab;
    display: inline-block;
    min-width: 5%;
}
</style>

<script>
import Draggable from "vuedraggable";
import XCheckboxWrapper from "./XCheckboxWrapper.vue";

export default {
    components: {
        Draggable,
        XCheckboxWrapper,
    },
    data() {
        return {
            fields: [...this.value],
            types: [
                { key: "textfield", label: "Text Field", hasOption: false },
                {
                    key: "textarea",
                    label: "Text Area (Deskripsi)",
                    hasOption: false,
                },
                { key: "number", label: "Number", hasOption: false },
                { key: "dropdown", label: "Dropdown", hasOption: true },
                { key: "checkbox", label: "Checkbox", hasOption: true },
                { key: "radio", label: "Radio Button", hasOption: true },
                {
                    key: "image_upload",
                    label: "Image Upload",
                    hasOption: false,
                },
                {
                    key: "bank_transfer",
                    label: "Bank Transfer",
                    hasOption: true,
                },
            ],
        };
    },
    methods: {
        addField() {
            this.fields.push({
                event_form_id: null,
                label: null,
                type: "textfield",
                options: null,
                is_required: true,
                is_individual: false,
            });
        },
        handleTypeChange(input, field) {
            this.$set(field, "type", input);
            if (input == "image_upload") {
                this.$set(field, "is_individual", 1);
            }
            if (input == "bank_transfer") {
                this.$set(field, "is_individual", 1);
                this.$set(field, "options", {
                    bank_name: "",
                    account_number: "",
                    account_name: "",
                    amount: null,
                    unique_code: null,
                });
            }
        },
        hasOptions(field) {
            const type = this.types.find((type) => {
                return type.key === field.type;
            });
            return type.hasOption;
        },
        removeField(targetIndex) {
            this.fields = this.fields.filter((field, index) => {
                return index != targetIndex;
            });
        },
        shouldDisable(field) {
            return Boolean(field.disabled) === true;
        },
    },
    props: {
        errors: {
            type: Object,
            required: false,
            default: () => ({}),
        },
        value: {
            type: Array,
            required: false,
            default: () => [],
        },
    },
    watch: {
        fields: {
            handler(fields) {
                this.$emit("input", [...fields]);
            },
            deep: true,
        },
    },
};
</script>
